<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRefresh_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M7.626 1.631c1.663 0 4.235 1.205 5.595 2.333l.861-2.643A.471.471 0 0 1 15 1.48l-.035 5.078a.474.474 0 0 1-.475.472l-5.037-.035a.476.476 0 0 1-.144-.928l2.312-.784.003.003.456-.156c-1.613-1.218-3.14-1.828-4.454-1.828-2.745 0-4.976 2.248-4.976 5.014s2.23 5.013 4.976 5.013a4.92 4.92 0 0 0 4.624-3.163l.025-.066.026-.072.16-.423a.816.816 0 0 1 1.054-.48c.423.161.604.64.476 1.063l-.053.143C13.089 13.037 10.594 15 7.626 15 3.96 15 1 12.009 1 8.316S3.96 1.63 7.626 1.63"
    />
</svg>
